import { inject } from '@angular/core';
import {
  HttpResponse,
  HttpErrorResponse,
  HttpInterceptorFn,
} from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';

import { LoaderService } from '../../classes/loader/loader.service';
import { Router } from '@angular/router';
import { NotificationsService } from '../../classes/notifications/notifications.service';
import { CredentialsService } from 'src/services/core/credentials/credentials.service';
import { throwError } from 'rxjs';

export const HttpErrorInterceptor: HttpInterceptorFn = (request, next) => {
  let errorMessage!: string;
  const loaderService = inject(LoaderService);
  const router = inject(Router);
  const notification = inject(NotificationsService);
  const credentialsService = inject(CredentialsService);

  loaderService.show();

  return next(request).pipe(
    tap((evt) => {
      if (evt && evt instanceof HttpResponse) {
        loaderService.hide();

        // ToDo: double-check this bit!
        // if (evt.body.error) {
        //   errorMessage = evt.body.message;
        //   notification.publishMessages(errorMessage, 'danger', 1);
        // }
      }
    }),

    catchError((error: HttpErrorResponse) => {
      loaderService.hide();

      if (error !== null && error && error.error instanceof ErrorEvent) {
        //client-side error
        errorMessage = `Error: ${error.error.message}`;
      } else {
        // server-side error
        switch (error.status) {
          case 500:
          case 502:
          case 503: {
            errorMessage = 'An internal error occurred.';
            notification.publishMessages(errorMessage, 'danger', 1);
            break;
          }
          case 400: {
            errorMessage = error.error.message || error.message;
            notification.publishMessages(errorMessage, 'danger', 1);
            break;
          }
          case 409:
          case 404: {
            errorMessage = error.error.message || error.statusText;
            notification.publishMessages(errorMessage, 'danger', 1);
            break;
          }
          case 403: {
            notification.publishMessages(
              'You are not authorized for the operation',
              'danger',
              1
            );
            break;
          }
          case 401: {
            notification.publishMessages(
              'Your session has expired',
              'danger',
              1
            );
            credentialsService.setCredentials();
            router.navigate(['/auth']);
            break;
          }
          case 0: {
            errorMessage =
              'A connection error occurred. Please, check your network connection';
            notification.publishMessages(errorMessage, 'danger', 1);
            break;
          }
        }
      }

      return throwError(() => error.error);
    })
  );
};
